import { APP_COLOR } from './Common.constants';

interface CloseIconProps {
  color?: string;
  size?: number;
}
export default function CloseIcon({
  color = APP_COLOR['icon-default'],
  size = 12,
}: CloseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <g>
            <g>
              <g>
                <path
                  d="M13.41 12l4.3-4.29c.392-.392.392-1.028 0-1.42-.392-.392-1.028-.392-1.42 0L12 10.59l-4.29-4.3c-.392-.392-1.028-.392-1.42 0-.392.392-.392 1.028 0 1.42l4.3 4.29-4.3 4.29c-.392.389-.395 1.022-.006 1.414l.006.006c.389.392 1.022.395 1.414.006l.006-.006 4.29-4.3 4.29 4.3c.389.392 1.022.395 1.414.006l.006-.006c.392-.389.395-1.022.006-1.414l-.006-.006-4.3-4.29z" // NOSONAR
                  transform="translate(-1350.000000, -417.000000) translate(421.000000, 214.000000) translate(17.000000, 158.000000) translate(906.000000, 39.000000)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
